import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";
import type { ApiResponse } from "./api-client.service";

import type {
  Airport,
  AirportFilter,
  AirportApiResponse,
  AirportPayload,
} from "../types/airports.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.airports;

const failure = (error: unknown, fallback: string) => ({
  success: false,
  statusCode: 500,
  message: error instanceof Error ? error.message : fallback,
  resData: null,
});

export const airportsService = {
  async list(filter: AirportFilter): Promise<AirportApiResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      return await apiClient<AirportApiResponse>(endpoints.list(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load airports0 list.") as unknown as AirportApiResponse;
    }
  },

  async details(id: number | string): Promise<ApiResponse<Airport>> {
    try {
      return await apiClient<ApiResponse<Airport>>(endpoints.details(id), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load airports0 details.") as unknown as ApiResponse<Airport>;
    }
  },

  async create(payload: AirportPayload): Promise<ApiResponse<Airport>> {
    try {
      return await apiClient<ApiResponse<Airport>>(endpoints.create, {
        method: "POST",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to create airports0.") as unknown as ApiResponse<Airport>;
    }
  },

  async update(id: number | string, payload: Partial<AirportPayload>): Promise<ApiResponse<Airport>> {
    try {
      return await apiClient<ApiResponse<Airport>>(endpoints.update(id), {
        method: "PATCH",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to update airports0.") as unknown as ApiResponse<Airport>;
    }
  },

  async delete(id: number | string): Promise<ApiResponse<unknown>> {
    try {
      return await apiClient<ApiResponse<unknown>>(endpoints.delete(id), {
        method: "DELETE",
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to delete airports0.") as unknown as ApiResponse<unknown>;
    }
  },
};
